import { InputBase, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { useOrdersContext } from 'contexts/OrdersContext';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import * as store from 'store';
import { getStores } from '../../api';
import { AnalyticsOrderSummary } from '../../types';
import { useAnalyticsStyles } from './Styles';

export interface FilterProps {
  endDate: string;
  startDate: string;
  setEndDate: (date: string) => void;
  setstartDate: (date: string) => void;
  setSelectedIndex: (date: number) => void;
  selectedIndex: number;
  data?: AnalyticsOrderSummary;
  shopID: number;
  setShopID: (shopID: number | undefined) => void;
}

interface Store {
  name: string;
  shopID: number;
}

export default function AnalyticsFilters(props: FilterProps) {
  const classes = useAnalyticsStyles();
  const theme = useTheme();
  const { orders } = useOrdersContext();

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const { data } = props;
  const accessToken = store.get('spotlightAccessToken');

  useEffect(() => {
    if (!props.shopID && !!data?.storeID) {
      props.setShopID(data.storeID);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const { data: storesData } = useQuery<any, Error>(['getStores'], getStores, {
    enabled: !!accessToken,
  });

  if (orders?.length) {
    //get stores for current orders in order to filter out mall selection filter
    const currentStores = orders.map((value: any) => value.shopName);
    store.remove('currentStores');
    store.set('currentStores', currentStores);
  }
  let stores: Array<Store> = [];
  if (storesData?.data) {
    const allStores = storesData.data.details;
    const currentStores = store.get('currentStores');

    if (currentStores !== undefined) {
      let filter = allStores.filter((value: any) => currentStores.includes(value.name));
      stores = filter;
    } else stores = allStores;
  }
  stores.sort((a: Store, b: Store) => (a.name > b.name ? 1 : -1));

  const handleStoreChange = (event: ChangeEvent<{ value: unknown }>): void => {
    const selectedShopID = event.target.value as number;
    if (props.setShopID) {
      props.setShopID(selectedShopID === 0 ? undefined : selectedShopID);
    }
  };

  return (
    <div className={classes.appBar}>
      <div className={`filters ${classes.filters} ${classes.toolBar}`}>
        <Typography className={classes.filterHeading} variant="h6" noWrap>
          {data?.storeID && `${data?.storeName} (${data?.storeLocation})`}
        </Typography>

        <div className={classes.filterSection}>
            <div className={classes.dateFilter} style={{ minWidth: 180, width: isMobile ? '100%' : '180px' }}>
              <div className={classes.filterName}>Store</div>
              <FormControl variant="outlined" style={{ flex: 1, marginLeft: '10px' }}>
                <Select
                  id="store-select"
                  value={props.shopID || 0}
                  onChange={handleStoreChange}
                  displayEmpty
                  renderValue={(value) => {
                    if (value === 0 || !value) return 'Select Store';
                    const selectedStore = stores.find((store) => store.shopID === value);
                    return selectedStore ? selectedStore.name : 'Select Store';
                  }}
                  input={
                    <InputBase
                      style={{
                        height: '30px',
                        border: 'none',
                        background: 'transparent',
                      }}
                    />
                  }
                  style={{
                    height: '30px',
                  }}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                    transformOrigin: {
                      vertical: 'top',
                      horizontal: 'left',
                    },
                    getContentAnchorEl: null,
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                      },
                    },
                  }}
                >
                  <MenuItem value={0}>
                    <em>Select Store</em>
                  </MenuItem>
                  {stores.map((store: Store) => (
                    <MenuItem key={store.shopID} value={store.shopID}>
                      {store.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          <DateFilter value={props.startDate} onChange={props.setstartDate} title="From" />
          <DateFilter value={props.endDate} onChange={props.setEndDate} title="To" />
        </div>
      </div>
    </div>
  );
}

function DateFilter(props: any) {
  const classes = useAnalyticsStyles();
  const [date, setDate] = useState(props.value);
  const { title = '', onChange = () => {} } = props;
  const handleChange = (event: any) => {
    event.preventDefault();
    setDate(event.target.value);
    onChange(event.target.value);
  };
  return (
    <div className={classes.dateFilter}>
      <div className={classes.filterName}>{title}</div>
      <input className={classes.filterInput} type="date" onChange={handleChange} value={date} />
    </div>
  );
}
